import { render, staticRenderFns } from "./CalendarActivitySidebar.vue?vue&type=template&id=42ed9c60&scoped=true"
import script from "./CalendarActivitySidebar.vue?vue&type=script&lang=js"
export * from "./CalendarActivitySidebar.vue?vue&type=script&lang=js"
import style0 from "./CalendarActivitySidebar.vue?vue&type=style&index=0&id=42ed9c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed9c60",
  null
  
)

export default component.exports